export const WAITING_TIERS: { afterMs: number; lines: string[] }[] = [
  { afterMs: 0, lines: ['Working on it', 'On it', 'Looking into it'] },
  { afterMs: 10_000, lines: ['Thinking it through', 'Putting it together', 'Getting the details right'] },
  { afterMs: 25_000, lines: ['Digging a little deeper', 'This needs a closer look', 'Taking a more thorough look'] },
  {
    afterMs: 45_000,
    lines: ['Longer answers can take a minute', 'Answers with more detail can take a minute', 'Some answers need a minute'],
  },
  {
    afterMs: 90_000,
    lines: [
      'Complex questions can take a couple of minutes',
      'Questions with many parts can take a couple of minutes',
      'Feel free to carry on. You can come back to this conversation later',
    ],
  },
];

// Picks one line per tier for a single reply. Each tier avoids the last line it
// actually showed, so no tier repeats itself on the replies that reach it.
export const pickWaitingLines = (
  random: () => number,
  previousLines: string[] = [],
): { afterMs: number; text: string }[] => WAITING_TIERS.map(({ afterMs, lines }, tier) => {
  const candidates = lines.filter((line) => line !== previousLines[tier]);
  return { afterMs, text: candidates[Math.floor(random() * candidates.length)] };
});

// A reply that ends before a tier never showed that tier's pick, so the tier
// keeps the line it last showed.
export const rememberShownLines = (
  previousLines: string[],
  picked: { afterMs: number; text: string }[],
  elapsedMs: number,
): string[] => picked.map(({ afterMs, text }, tier) => (
  afterMs <= elapsedMs ? text : previousLines[tier]
));
